<script>
export default {
  name: "CheckForColumn",
  functional: true,
  props: {
    row: Object,
    column: String
  },
  render: function (createElement, context) {
    //console.log("contexto: ", context)
    let val = "";
    const { column } = context.props;
    const { rowValue } = context.data.attrs;
    const LookingForward = context.props.row.LookingForward;
    let element;
    if (column === "LookingForward") {
      if (LookingForward == true) {
        val = "Si";
        element = createElement(
          "span",
          {
            class: "el-tag  el-tag--success el-tag--plain"
          },
          val
        );
      } else {
        val = "No";
        element = createElement(
          "span",
          {
            class: "el-tag el-tag--danger el-tag--plain"
          },
          val
        );
      }
    } else if (column === "Type") {
      let clase;
      switch (rowValue) {
        case 1:
          clase = "el-tag  el-tag--primary el-tag--plain";
          val = "Ingreso";
          break;
        case 0:
          clase = "el-tag el-tag--warning el-tag--plain";
          val = "Egreso";
          break;
      }
      element = createElement(
        "span",
        {
          class: clase
        },
        val
      );
    } else if (
      column === "Contratos" ||
      column === "RegistroMercantil" ||
      column === "Cedula" ||
      column === "Otros"
    ) {
      let clase;
      if (rowValue > 0) {
        clase = "el-tag  el-tag--success el-tag--plain el-icon-success";
        val = "";
      } else {
        clase = "el-tag el-tag--warning el-tag--plain el-icon-error";
        val = "";
      }

      element = createElement(
        "span",
        {
          class: clase
        },
        val
      );
    }
    return element;
  }
};
</script>
